import { CalendarOptions } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import { TranslateService } from "@ngx-translate/core";
import { Campaign } from "../../../models/campaign";

export const PublicationCalendarConfig = (
  campaign: Campaign,
  translateService: TranslateService,
): CalendarOptions => ({
  initialView: "dayGridMonth",
  dayMaxEventRows: 10,
  dayMaxEvents: 10,
  plugins: [dayGridPlugin, interactionPlugin],
  headerToolbar: {
    left: "today prev,next title",
    center: "",
    right: "",
  },
  buttonText: {
    today: translateService.instant("shared.today"),
  },
  firstDay: 1,
  droppable: false,
  weekends: true,
  editable: false,
  selectable: false,
  selectMirror: true,
  validRange: {
    start: campaign.startDate,
    end: campaign.endDate,
  },
  dayCellClassNames: (args) => {
    const classes = ["sp-day"];
    if (args.date.isInDayRange(campaign) && args.date.isTodayOrFutureDay()) {
      classes.push("sp-day--inside-range");
    }

    return classes.join(" ");
  },
});
